// extracted by mini-css-extract-plugin
export const section = "index-module--section--2LN3I";
export const border = "index-module--border--1oJue";